<script setup lang="ts">
import Skeleton from "@/design/primitives/Skeleton.vue";

/**
 * A TELA QUE JÁ ABRIU, enquanto o código dela chega.
 *
 * O que esta peça cobre é um vazio que nenhum esqueleto de página conseguia
 * cobrir, por uma razão de ordem: os esqueletos do painel vivem DENTRO do
 * componente de cada tela, e o componente de cada tela é exactamente a coisa que
 * está a ser descarregada. Enquanto o chunk não chegava não havia quem
 * desenhasse — o `<RouterView>` continuava a mostrar a tela ANTERIOR e o clique
 * no menu parecia não ter feito nada (238 kB na de Canais, 129 kB na de
 * Conversas). Ver `lazy-page.ts` para como isto passa a ser desenhado.
 *
 * ── POR QUE TEM A FORMA DE UMA PÁGINA E NÃO É UM SPINNER ──────────────────
 *
 * Porque o que vem a seguir é sempre um cabeçalho e uma lista, e um bloco com
 * essa geometria não empurra o conteúdo quando ele chega. Um spinner centrado
 * seria uma terceira linguagem visual num painel que já tem duas — o `Skeleton`
 * das listas e o `EmptyState` do nada.
 *
 * Genérico de propósito. Um esqueleto por tela seriam sessenta e um arquivos
 * cinzentos para manter em dia, e o que se ganharia é invisível: isto vive por
 * uma fracção de segundo e o esqueleto VERDADEIRO da tela — o que conhece a
 * forma dos dados — assume mal o chunk aterra.
 */
</script>

<template>
	<main class="min-w-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6">
		<!-- O cabeçalho, na métrica do `PageHeader`: título, subtítulo, e o mesmo
		     respiro por baixo. É o que impede o salto quando o real entra. -->
		<div class="mb-5 animate-pulse space-y-2" aria-hidden="true">
			<div class="h-6 w-48 rounded bg-bg-muted" />
			<div class="h-3.5 w-72 max-w-full rounded bg-bg-muted" />
		</div>
		<Skeleton :rows="5" />
	</main>
</template>
